const Linkedin = ({
  color = "var(--primary500)",
  size = 24,
  onClick = () => {},
}) => {
  return (
    <svg
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="2" fill={color} />
      <g clipPath="url(#clip0_2954_6141)">
        <rect x="4.00012" y="4" width="16" height="15" rx="2" fill={color} />
        <path
          d="M7.63281 19V8.87953H4.20251V19H7.63281ZM5.9181 7.49692C7.11431 7.49692 7.85889 6.71978 7.85889 5.74862C7.8366 4.75556 7.11436 4 5.9408 4C4.76743 4 4.00012 4.75558 4.00012 5.74862C4.00012 6.71983 4.74452 7.49692 5.89571 7.49692H5.918H5.9181ZM9.53147 19H12.9618V13.3482C12.9618 13.0458 12.9841 12.7436 13.0746 12.5274C13.3226 11.923 13.8871 11.2971 14.8346 11.2971C16.0759 11.2971 16.5725 12.2252 16.5725 13.5857V18.9999H20.0026V13.1969C20.0026 10.0883 18.3103 8.64193 16.0533 8.64193C14.2028 8.64193 13.3903 9.65626 12.939 10.3471H12.9619V8.87932H9.53155C9.57657 9.82897 9.53155 18.9998 9.53155 18.9998L9.53147 19Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2954_6141">
          <rect x="4.00012" y="4" width="16" height="15" rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Linkedin;
